import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { FormProvider, useForm } from 'react-hook-form';
import { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { BaseDrawer, BaseDrawerTitle } from '@mgm/common/components/base';
import { useAppDispatch, useAppSelector } from '../../../hooks/useAppStore';
import { getIsOpenFeedbackNav } from '../../../store/help/selectors';
import { helpActions } from '../../../store/help/slice';
import { RadioGroupRating } from '../../../components';
import { useFeedbackAPI } from '../../../hooks/api';
import { commonActions } from '../../../store/common/slice';

const SendFeedback = () => {
  const { mutateAsync, isLoading } = useFeedbackAPI();
  const isOpenFeedbackNav = useAppSelector(getIsOpenFeedbackNav);
  const { t } = useTranslation('help');
  const dispatch = useAppDispatch();
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  const [rating, setRating] = useState<number | null>(5);
  const [feedback, setFeedback] = useState('');

  const methods = useForm({
    mode: 'all',
  });

  const handleClose = () => {
    dispatch(helpActions.setIsOpenFeedbackNav(false));
  };

  const sendFeedback = async () => {
    const data = {
      rating: rating as string | number,
      message: feedback,
    };

    await mutateAsync(data);
    handleClose();
  };

  const onCloseDrawer = () => {
    dispatch(commonActions.setToggleDrawer(false));
  };

  return (
    <BaseDrawer
      open={isOpenFeedbackNav}
      drawerProps={{
        anchor: 'right',
        width: isMobile ? 'auto' : 600,
        variant: 'persistent',
      }}
      onCloseDrawer={onCloseDrawer}
    >
      <BaseDrawerTitle
        title={t('feedbackToManageMate')}
        handleClose={handleClose}
      />
      <Divider sx={{ borderStyle: 'dashed' }} />
      <FormProvider {...methods}>
        <Box
          paddingRight={isMobile ? 2 : 5}
          paddingLeft={isMobile ? 2 : 5}
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Typography py={2}>{t('feelFreeToShare')}</Typography>
          <Grid paddingTop={2} container spacing={4}>
            <Grid size={{
              xs: 12, sm: 6, md: 6, lg: 6,
            }}
            >
              <RadioGroupRating onChange={setRating} />
            </Grid>
            <Grid size={{
              xs: 12, sm: 12, md: 12, lg: 12,
            }}
            >
              <TextField
                value={feedback}
                placeholder={t('tellUsAbout')}
                onChange={(event) => setFeedback(event.target.value)}
                multiline
                fullWidth
                rows={5}
              />
            </Grid>
            <Grid
              size={{
                xs: 12, lg: 12,
              }}
              paddingTop={4}
            >
              <LoadingButton
                onClick={methods.handleSubmit(sendFeedback)}
                loading={isLoading}
                size="large"
                variant="contained"
              >
                {t('sendFeedback')}
              </LoadingButton>
            </Grid>
          </Grid>
        </Box>
      </FormProvider>
    </BaseDrawer>

  );
};

export {
  SendFeedback,
};
